import { styled } from '@mui/material/styles';
import { Datagrid } from 'shared/react-admin/Datagrids';

export const DatagridStyled = styled(Datagrid)({
  '& .column-provider': {
    width: '50%',
  },

  '& .column-percent': {
    width: '50%',
  },
});
